/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5AwsDeployerV1StackState } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_AWS_DEPLOYER_V1_STACK_STATE_ENTITY_NAME = 'o5.aws.deployer.v1.Stack';
export const o5AwsDeployerV1StackStateEntity = new schema.Entity<O5AwsDeployerV1StackState>(O5_AWS_DEPLOYER_V1_STACK_STATE_ENTITY_NAME, {}, { idAttribute: 'stackId' });

